import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";
import { api, API } from "../../lib/api";

const IMG = API.replace(/\/api$/, "");

// Home page "Kingdom Showcase" strip — rotating, parent-approved featured artwork.
// Renders nothing until there is at least one featured piece (keeps Home clean at launch).
export default function FeaturedShowcase() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/showcase/featured`, { params: { limit: 8 } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section className="max-w-6xl mx-auto px-6 mt-16" data-testid="home-featured-showcase">
      <div className="rounded-[2.5rem] bg-gradient-to-br from-pinkK/10 via-goldK/10 to-purpleK/10 border border-white/60 p-6 sm:p-8 shadow-sm">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/70 px-3 py-1 text-xs font-display font-bold text-pinkK"><Sparkles size={13} /> Kingdom Showcase</span>
            <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-ink mt-2">Young Artists of the Kingdom</h2>
            <p className="text-ink/55 text-sm mt-1">Real artwork from our creative community — shared with a grown-up's blessing. 💛</p>
          </div>
          <Link to="/showcase" data-testid="showcase-view-more" className="inline-flex items-center gap-1.5 rounded-full bg-purpleK text-white font-display font-bold px-5 py-2.5 text-sm hover:-translate-y-0.5 transition-transform">
            View More Artwork <ArrowRight size={16} />
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.slice(0, 8).map((it, i) => (
            <motion.div key={it.id} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="rounded-2xl bg-white border border-black/5 overflow-hidden shadow-sm" data-testid={`showcase-featured-${it.id}`}>
              <div className="aspect-square bg-cream/40 grid place-items-center overflow-hidden">
                <img src={`${IMG}${it.imageUrl}`} alt={it.title || "Kingdom artwork"} loading="lazy" className="h-full w-full object-contain" />
              </div>
              <div className="p-3">
                {it.recognition && <span className="inline-block text-[11px] font-bold text-goldDark mb-0.5">{it.recognition.emoji} {it.recognition.label}</span>}
                <p className="font-display font-bold text-ink text-sm truncate">{it.title || "A Kingdom Creation"}</p>
                <p className="text-xs text-ink/50">by {it.displayName}</p>
                {it.message && <p className="text-[11px] text-ink/45 italic mt-1 line-clamp-2">“{it.message}”</p>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
